import { Directive } from '../../../types';

/**
 * Unified access entry for RBAC policies
 * Represents a user or team with a role
 */
export interface UnifiedAccess {
  Id: number;
  Type: 'user' | 'team';
  Name: string; // Username for users, team name for teams
  Role: {
    Id: number;
    Name: string;
  };
}

/**
 * Form data for Docker RBAC Policy
 */
export interface DockerRBACFormData {
  /** List of user/team access entries */
  accessList: UnifiedAccess[];
}

/**
 * Access policy value structure for backend
 */
export interface AccessPolicyValue {
  RoleId: Directive<number>;
}

/**
 * Stored policy data structure (from backend)
 * This is what comes back from the API in policy.Data
 */
export interface DockerRBACPolicyData {
  EnvironmentAccessPolicies: {
    UserAccessPolicies: Record<string, AccessPolicyValue>;
    TeamAccessPolicies: Record<string, AccessPolicyValue>;
  };
}

/**
 * API payload for Docker RBAC Policy
 * Uses PascalCase to match backend expectations
 */
export interface DockerRBACPolicyPayload {
  EnvironmentAccessPolicies: {
    UserAccessPolicies: Record<string, AccessPolicyValue>;
    TeamAccessPolicies: Record<string, AccessPolicyValue>;
  };
}

/**
 * Default initial values for Docker RBAC Policy (create mode)
 */
export const DOCKER_RBAC_INITIAL_VALUES: DockerRBACFormData = {
  accessList: [],
};
